import { SvgIconComponent } from '@mui/icons-material';
import InfoIcon from '@mui/icons-material/InfoOutlined';

import Tooltip from '../Tooltip';

export default function TooltipIcon({
  tooltip,
  Icon = InfoIcon,
}: {
  tooltip: string;
  Icon?: SvgIconComponent;
}) {
  return (
    <Tooltip title={tooltip} placement="top">
      <Icon
        sx={(theme) => ({
          color: theme.palette.secondary.light,
          fontSize: 20,
          verticalAlign: 'sub',
          position: 'relative',
          bottom: '-1px',
          p: '0px 1px',
          cursor: 'pointer',
        })}
      />
    </Tooltip>
  );
}
